<div *ngIf="isMobile" class="gyanTile mt-3 mb-2">{{ gyanTitle }}</div>
<div class="articleTile mt-2">{{ articleTitle }}</div>
<div *ngIf="(nodes.length > 0 || links.length > 0) && isCompleted" class="graph-container" [attr.id]="'article-network'" [attr.data-test]="'article-network'">
    <graph [nodes]="nodes" [links]="links" (nodeDoubleClickEmmiter)="onDoubleClickSelectedNode($event)" (nodeSingleClickEmmiter)="onSingleClickSelectedNode($event)"> </graph>
</div>

<div *ngIf="(nodes.length == 0 || links.length == 0) && isCompleted && !loadingGraph" class="graph-inprogress-background-image vh-80">
    <div class="d-flex justify-content-center align-items-center align-middle h-100 px-5">
        <div class="px-3">
            <div class="d-flex justify-content-center align-items-center position-relative">
                <!-- <div class="sub-head-s4 text-center color-teal article-network-not-avail">{{ 'graph.articleNetworkNotAvail' | translate }}</div> -->
                <div class="sub-head-s4 text-center color-teal article-network-not-avail">{{ message }}</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="loadingGraph">
    <div class="no-summary-message">
        <span><img style="height: 35px" src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></span>
        <span>Loading Article Network</span>
    </div>
</div>
